import {
    FETCH_SELECTED_FIELDS,
    FETCH_SELECTED_FIELDS_SUCCESS,
    SAVE_SELECTED_FIELDS,
    SAVE_SELECTED_FIELDS_SUCCESS,
    FETCH_USER_PREFERENCE,
    FETCH_USER_PREFERENCE_SUCCESS,
    FETCH_USER_PREFERENCE_FAIL,
    SAVE_USER_PREFERENCE,
    SAVE_USER_PREFERENCE_SUCCESS,
    SAVE_USER_PREFERENCE_FAIL
} from '../../actions/userPreferenceActions';

const INITIAL_STATE = {
    finishedFetching: false,
    userPreferenceSaving: false
};

// --- TODO: These are actions. Should be moved to their own file.
export function fetchSelectedFields() {
    return {
        type: FETCH_SELECTED_FIELDS,
        payload: {}
    };
}

export function saveSelectedFields(selectedFields) {
    return {
        type: SAVE_SELECTED_FIELDS,
        payload: {
            selectedFields: selectedFields
        }
    };
}

export const saveUserPreference = (key, userPreference, callback) => {
    return {
        type: SAVE_USER_PREFERENCE,
        userPreference: userPreference,
        preferenceKey: key,
        callback: callback
    };
};

export const fetchUserPreference = (key, evictCache, callback) => {
    return {
        type: FETCH_USER_PREFERENCE,
        key: key,
        meta: {
            cacheTime: evictCache ? null : 120000
        },
        callback
    };
};

// ---

const updateSelectedFields = (state, action) => {
    return {
        ...state,
        selectedFields: action.selectedFields
    };
};

const fetchUserPreferenceSuccess = (state, action) => {
    if (!state.userPreferences) {
        state.userPreferences = {};
    }

    state.userPreferences[action.preferenceKey] = action.value;

    return {
        ...state,
        finishedFetching: true
    };
};

const fetchUserPreferenceFail = (state, action) => {
    return state;
};

const userPreferenceSaving = (state, action) => {
    state.userPreferenceSaving = true;
    return state;
};

const saveUserPreferenceSuccess = (state, action) => {
    if (!state.userPreferences) {
        state.userPreferences = {};
    }

    state.userPreferences[action.preferenceKey] = action.value;
    state.userPreferenceSaving = false;

    return state;
};

const saveUserPreferenceFail = (state, action) => {
    if (!state.userPreferences) {
        state.userPreferences = {};
    }

    state.userPreferences[action.preferenceKey] = null;
    state.userPreferenceSaving = false;

    return state;
};

const handlers = {
    [FETCH_SELECTED_FIELDS_SUCCESS]: updateSelectedFields,
    [SAVE_SELECTED_FIELDS_SUCCESS]: updateSelectedFields,
    [FETCH_USER_PREFERENCE_SUCCESS]: fetchUserPreferenceSuccess,
    [FETCH_USER_PREFERENCE_FAIL]: fetchUserPreferenceFail,
    [SAVE_USER_PREFERENCE]: userPreferenceSaving,
    [SAVE_USER_PREFERENCE_SUCCESS]: saveUserPreferenceSuccess,
    [SAVE_USER_PREFERENCE_FAIL]: saveUserPreferenceFail
};

export default function preference(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// selectors

export const getUserPreference = (state, key, jsonParse, defaultValue) => {
    let value = state.preference && state.preference.userPreferences ? state.preference.userPreferences[key] : null;

    if ((value === null || typeof value === 'undefined') && defaultValue) {
        value = defaultValue;
    }

    if (value != null && jsonParse) {
        value = JSON.parse(value);
    }

    return value;
};

export const fetchUserPreferenceFinished = (state) => {
    return state.preference.finishedFetching;
};

export const isSaveUserPreferenceFinished = (state) => {
    return !state.preference.userPreferenceSaving;
};
